'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var axios = _interopDefault(require('axios'));
var axiosRetry = _interopDefault(require('axios-retry'));
var uuid = _interopDefault(require('uuid/v4'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray = _arrayLikeToArray;

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray = _unsupportedIterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var defaultRetryCondition = function defaultRetryCondition(error) {
  return error.code !== "ECONNABORTED";
};
function isHeaderExcluded(headerLoggingExcludes, header) {
  var _iterator = _createForOfIteratorHelper(headerLoggingExcludes),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var excludedHeader = _step.value;
      if (excludedHeader.toLowerCase() === header.toLowerCase()) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function filterHeaders(headerLoggingExcludes) {
  return function (headers) {
    if (headerLoggingExcludes) {
      return Object.keys(headers).reduce(function (acc, headerName) {
        if (!isHeaderExcluded(headerLoggingExcludes, headerName)) {
          acc[headerName] = headers[headerName];
        }
        return acc;
      }, {});
    }
    return headers;
  };
}
var getClientRequestInterceptor = function getClientRequestInterceptor() {
  return function (request) {
    return request;
  };
};
var getClientResponseInterceptor = function getClientResponseInterceptor() {
  return [function (response) {
    return response;
  }, function (error) {
    return Promise.reject(error);
  }];
};
var getRequestInterceptor = function getRequestInterceptor(_ref3) {
  var logger = _ref3.logger,
    filterHeadersInstance = _ref3.filterHeadersInstance;
  return  getClientRequestInterceptor();
};
var getResponseInterceptor = function getResponseInterceptor(_ref4) {
  var serverRequestLogger = _ref4.serverRequestLogger,
    logger = _ref4.logger,
    filterHeadersInstance = _ref4.filterHeadersInstance;
  return  getClientResponseInterceptor();
};
function enhanceAxios() {
  var _axiosInstance$interc;
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    serverRequestLogger = _ref5.serverRequestLogger,
    httpsAgent = _ref5.httpsAgent,
    retries = _ref5.retries,
    retryDelay = _ref5.retryDelay,
    _ref5$retryCondition = _ref5.retryCondition,
    retryCondition = _ref5$retryCondition === void 0 ? defaultRetryCondition : _ref5$retryCondition,
    shouldResetTimeout = _ref5.shouldResetTimeout,
    logger = _ref5.logger,
    headerLoggingExcludes = _ref5.headerLoggingExcludes;
  var axiosInstance = axios.create({
    httpsAgent: httpsAgent
  });
  var filterHeadersInstance = filterHeaders(headerLoggingExcludes);
  axiosInstance.interceptors.request.use(getRequestInterceptor({
    logger: logger,
    filterHeadersInstance: filterHeadersInstance
  }));
  (_axiosInstance$interc = axiosInstance.interceptors.response).use.apply(_axiosInstance$interc, toConsumableArray(getResponseInterceptor({
    serverRequestLogger: serverRequestLogger,
    logger: logger,
    filterHeadersInstance: filterHeadersInstance
  })));
  axiosRetry(axiosInstance, {
    retries: retries,
    retryDelay: retryDelay,
    retryCondition: retryCondition,
    shouldResetTimeout: shouldResetTimeout
  });
  return axiosInstance;
}

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CancelToken = axios.CancelToken,
  isCancel = axios.isCancel;
var SUPPORTED_HTTP_METHODS = ["get", "post", "delete", "patch", "put"];
var ASOS_CORRELATION_HEADER = "asos-cid";
var ASOS_SESSION_CORRELATION_HEADER = "asos-sid";
var ASOS_CLIENT_NAME_HEADER = "asos-c-name";
var ASOS_CLIENT_VERSION_HEADER = "asos-c-ver";
var ASOS_CLIENT_PLATFORM_HEADER = "asos-c-plat";
var DEFAULT_PLATFORM = "web";
var CONTENT_TYPE_HEADER = ["Content-Type", "content-type"];
var configureRequest = function configureRequest(_ref) {
  var defaultTimeout = _ref.defaultTimeout,
    _ref$retries = _ref.retries,
    retries = _ref$retries === void 0 ? 0 : _ref$retries,
    logger = _ref.logger,
    serverRequestLogger = _ref.serverRequestLogger,
    httpsAgent = _ref.httpsAgent,
    retryDelay = _ref.retryDelay,
    retryCondition = _ref.retryCondition,
    shouldResetTimeout = _ref.shouldResetTimeout,
    client = _ref.client,
    getSid = _ref.getSid,
    headerLoggingExcludes = _ref.headerLoggingExcludes,
    _ref$validateStatus = _ref.validateStatus,
    validateStatus = _ref$validateStatus === void 0 ? function (status) {
      return status >= 200 && status < 300;
    } : _ref$validateStatus;
  var name = client.name,
    version = client.version,
    _client$platform = client.platform,
    platform = _client$platform === void 0 ? DEFAULT_PLATFORM : _client$platform;
  var defaultValidateStatus = validateStatus;
  var axiosInstance = enhanceAxios({
    retries: retries,
    logger: logger,
    serverRequestLogger: serverRequestLogger,
    httpsAgent: httpsAgent,
    retryDelay: retryDelay,
    retryCondition: retryCondition,
    shouldResetTimeout: shouldResetTimeout,
    headerLoggingExcludes: headerLoggingExcludes
  });
  var trySetAsosSessionIdHeader = function trySetAsosSessionIdHeader(headers) {
    if (typeof getSid === "function") {
      headers[ASOS_SESSION_CORRELATION_HEADER] = getSid();
    }
  };
  var addStandardHeaders = function addStandardHeaders(_ref2) {
    var headers = _ref2.headers,
      cid = _ref2.cid,
      setAcceptEncoding = _ref2.setAcceptEncoding,
      isThirdParty = _ref2.isThirdParty;
    if (!isThirdParty) {
      {
        trySetAsosSessionIdHeader(headers);
      }
      headers[ASOS_CORRELATION_HEADER] = cid || uuid();
      headers[ASOS_CLIENT_PLATFORM_HEADER] = platform;
      headers[ASOS_CLIENT_NAME_HEADER] = name;
      headers[ASOS_CLIENT_VERSION_HEADER] = version;
    }
  };
  var getData = function getData(headers, body) {
    if (body === undefined) {
      return undefined;
    }
    var isXFormUrlEncodedRequest = !!headers && !!CONTENT_TYPE_HEADER.find(function (contentTypeHeader) {
      return headers[contentTypeHeader] === "application/x-www-form-urlencoded";
    });
    if (isXFormUrlEncodedRequest) {
      return body;
    }
    return JSON.stringify(body);
  };
  var request = function request(method) {
    return function (_ref3) {
      var url = _ref3.url,
        serverUuid = _ref3.uuid,
        cid = _ref3.cid,
        params = _ref3.params,
        maxRedirects = _ref3.maxRedirects,
        body = _ref3.body,
        _ref3$headers = _ref3.headers,
        headers = _ref3$headers === void 0 ? {} : _ref3$headers,
        _ref3$timeout = _ref3.timeout,
        timeout = _ref3$timeout === void 0 ? defaultTimeout : _ref3$timeout,
        _ref3$additionalLoggi = _ref3.additionalLoggingParams,
        additionalLoggingParams = _ref3$additionalLoggi === void 0 ? {} : _ref3$additionalLoggi,
        cancelTokenExecutor = _ref3.cancelTokenExecutor,
        _ref3$validateStatus = _ref3.validateStatus,
        validateStatus = _ref3$validateStatus === void 0 ? defaultValidateStatus : _ref3$validateStatus,
        _ref3$setAcceptEncodi = _ref3.setAcceptEncoding,
        setAcceptEncoding = _ref3$setAcceptEncodi === void 0 ? true : _ref3$setAcceptEncodi,
        _ref3$isThirdParty = _ref3.isThirdParty,
        isThirdParty = _ref3$isThirdParty === void 0 ? false : _ref3$isThirdParty;
      addStandardHeaders({
        headers: headers,
        cid: cid,
        setAcceptEncoding: setAcceptEncoding,
        isThirdParty: isThirdParty
      });
      return axiosInstance({
        method: method,
        headers: headers,
        url: url,
        params: params,
        maxRedirects: maxRedirects,
        data: getData(headers, body),
        timeout: timeout,
        asosConfig: _objectSpread(_objectSpread({}, additionalLoggingParams), {}, {
          serverUuid: serverUuid
        }),
        cancelToken: cancelTokenExecutor ? new CancelToken(cancelTokenExecutor) : undefined,
        validateStatus: validateStatus
      });
    };
  };
  return SUPPORTED_HTTP_METHODS.reduce(function (methods, method) {
    methods[method] = request(method);
    return methods;
  }, {});
};
var isCancelled = isCancel;

exports.configureRequest = configureRequest;
exports.isCancelled = isCancelled;
